import styled from 'styled-components';
import { YellowButton } from 'components/Buttons';

export default styled(YellowButton)`
  padding: 8px 24px;
  margin: 30px 0px 0px 15px;
  font-size: 14px;
  text-transform: uppercase;
  height: 50px;
`;
